import { type BufferGeometry, type Light, type Mesh, type MeshStandardMaterial, type Scene } from "three";
import { isLight, isMesh, isMeshWithStandardMaterial } from "../../utils/types.ts";

export default class SceneHelpers {
    readonly #scene: Scene;

    constructor(scene: Scene) {
        this.#scene = scene;
    }

    get scene() {
        return this.#scene;
    }

    traverseLights(callback: (light: Light) => void) {
        this.#scene.traverse((child) => {
            if (isLight(child)) callback(child);
        });
    }

    traverseMeshes(callback: (mesh: Mesh) => void) {
        this.#scene.traverse((child) => {
            if (isMesh(child)) callback(child);
        });
    }
    traverseMeshesWithMaterials(callback: (mesh: Mesh<BufferGeometry, MeshStandardMaterial>) => void) {
        this.#scene.traverse((child) => {
            if (isMeshWithStandardMaterial(child)) callback(child);
        });
    }
}
